export default __webpack_public_path__ + "static/media/ggb-foreground.04e8315c.svg";